module.exports = __webpack_public_path__ + "static/media/chatbox.44a7e649.png";